var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.882812 22.8377C2.63648 25.8747 4.39178 28.9111 6.14872 31.9468L47.2454 22.1109L55.115 20.002L0.882812 22.8377Z",
    fill: "#FE8700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4621 21.1348L16.8438 33.6695L19.332 37.9793C19.6792 38.6004 20.1877 39.1162 20.804 39.472C21.4202 39.8278 22.1211 40.0104 22.8326 40.0005H41.2305C41.9419 40.0104 42.6428 39.8277 43.259 39.4719C43.8752 39.1161 44.3837 38.6004 44.7309 37.9793L49.3393 29.9976L49.3441 30.0003L53.541 22.7315L43.7576 28.1658L40.259 34.2255H30.8955L44.6701 26.5743L54.4621 21.1348Z",
    fill: "#F7F8FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9346 19.089L54.6758 19.2431L54.6732 19.2382L47.6534 18.6018L17.8863 16.028L23.7996 5.77507H40.2544L44.3544 12.8765V12.8877L47.0815 17.6112L47.7291 17.6563L54.0931 18.2333L49.3396 10.0002L49.3347 10.003L44.7265 2.02108C44.3792 1.40009 43.8706 0.884479 43.2544 0.52878C42.6382 0.173082 41.9373 -0.00948303 41.2259 0.000381031H22.8279C22.1164 -0.00950361 21.4155 0.173097 20.7993 0.52886C20.1831 0.884623 19.6745 1.40033 19.3273 2.02142L14.7189 10.0033C12.9673 13.0321 11.632 15.3389 9.88281 18.3688L47.9346 19.089Z",
    fill: "#F7F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablogo);
export default __webpack_public_path__ + "static/media/Tablogo.9b7b1f0d69214f146b9a74d9d78f2a3a.svg";
export { ForwardRef as ReactComponent };